import logger from '~/utils/logger/logger';
import { waitForTokenRefreshResponse } from '../hooks/use-native-app-listener';
import { NativeCommandEnum } from '../models/commands';
import Store from '~/store/Store';
import HybridWebView from './HybridWebView';
import { hasWebViewHost } from './has-webview-host';

export const refreshToken = async (): Promise<number> => {
  logger.debug('refreshToken');
  HybridWebView.SendInvokeMessageToDotNet(NativeCommandEnum.RefreshToken, []);
  return await waitForTokenRefreshResponse();
};

export const shouldUseNativeRefreshToken = (): boolean => {
  const nativeState = Store.getState().native;
  if (nativeState.onWebViewInitialized || nativeState.onWebView) {
    return true;
  }
  return hasWebViewHost();
};
